<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-RFID赋码</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="出库单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>出库单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="使用科室" v-if="getIsView()">
                <el-input disabled v-model="form.deptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>使用科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane label="单独RFID赋码" name="first">
            <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
              <div style="width: 88%; display: flex">
                <div class="start-label" />
                <span class="text">出库明细</span>
              </div>

              <div style="margin: 20px 0 12px 10px">
                <el-input v-model="udiNo" style="width: 25%" @change="udiNoChange" placeholder="条码"></el-input>

                <el-dropdown @command="batchPrintChange1" style="
                    float: right;
                    margin: 8px 10px;
                    background: #286ab4;
                    color: beige;
                  ">
                  <el-button type="primary" size="small">
                    批量打印<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">RFID打印</el-dropdown-item>
                    <el-dropdown-item command="2">普通打印</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <!-- <el-button class="btn default" style="
                    float: right;
                    margin: 8px 10px;
                    background: #286ab4;
                    color: beige;
                  " size="small" v-preventReClick @click="batchPrintChange">批量打印</el-button> -->

                <el-button class="btn default" style="
                    float: right;
                    margin: 8px 10px;
                    background: #286ab4;
                    color: beige;
                  " size="small" v-preventReClick @click="savePacks">批量赋码</el-button>
              </div>

              <el-table ref="singleTable" border :data="form.singleDetails" style="width: auto; margin: 0 10px"
                @selection-change="handleSelectionChange" :row-style="rowClass" stripe
                :header-cell-style="{ background: '#DDEBFF' }">
                <el-table-column type="index" width="50"> </el-table-column>
                <el-table-column align="center" type="selection" fixed width="55" />
                <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品" width="180" />
                <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号" width="120" />
                <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家" width="140" />
                <el-table-column prop="number" label="数量" width="50" />
                <el-table-column prop="minUnit" label="最小单位" width="80" />
                <el-table-column prop="price" label="单价" width="80" />
                <el-table-column prop="packSpec" label="包装规格" width="120" />
                <el-table-column prop="batch" label="批次号" width="120" />
                <el-table-column prop="validityDate" label="有效期" width="150">
                  <template slot-scope="scope">
                    {{
                      scope.row.validityDate
                        ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="serialNo" label="序列号" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="mainNo" label="主条码" width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="rfid" label="RFID码" width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="traceNo" label="追溯码" width="180"></el-table-column>
                <el-table-column label="库存类型" width="80">
                  {{ form.categoryName }}
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productRegistCertNo" label="注册证号"
                  width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productRegistCertName" label="产品注册证"
                  width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商" />
                <el-table-column fixed="right" prop="printingTimes" width="80" label="打印次数"></el-table-column>
                <el-table-column label="操作" align="center" width="140" fixed="right"
                  class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" v-if="!Boolean(scope.row.rfid)" v-preventReClick
                      class="color-blue" @click="setRFID(scope.row)">赋码</el-button>
                    <el-button size="mini" v-if="Boolean(scope.row.rfid)" type="text"
                      @click="print(scope.row.rfid)">RFID打印</el-button>
                    <el-button size="mini" v-if="Boolean(scope.row.rfid)" type="text"
                      @click="print1(scope.row.rfid)">普通打印</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="整包RFID赋码" name="second">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
                  <div style="width: 100%; display: flex">
                    <div class="start-label" />
                    <span style="flex: 6" class="text">待打包明细</span>
                    <div>
                   
                      <el-button type="primary" v-loading="creatPackLoading" :disabled="creatPackLoading" style="margin: 10px 10px; float: right" class="btn primary" size="small"
                        @click="creatPack">打包</el-button>
                      <el-button style="margin: 10px 10px; float: right" class="btn primary" type="primary" size="small"
                        v-preventReClick @click="batchPackEvt">批量打包</el-button>
                           <!-- <el-button  style="margin: 10px 10px; float: right" class="btn default" size="small"
                        @click="refreshEvt">刷新</el-button> -->
                    </div>
                  </div>
                  <!-- 
              <div style="margin: 20px 0 12px 10px">
              </div> -->

                  <el-table ref="singleTable" border :data="form.multipleDetails"
                    @selection-change="handleSelectionChange" style="width: auto; margin: 0 10px" stripe
                    :header-cell-style="{ background: '#DDEBFF' }" height="200">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品"
                      width="180"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号"
                      width="120"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家"
                      width="140"></el-table-column>
                    <el-table-column prop="number" label="数量" width="80"></el-table-column>
                    <el-table-column prop="number" label="可打包数量" width="100">
                      <template slot-scope="scope">
                        {{
                          scope.row.number - scope.row.packNumber - scope.row.refundNumber
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="thisPackNumber" label="本包数量" width="120">
                      <template slot-scope="scope">
                        <el-input-number controls-position="right" size="small" v-model="scope.row.thisPackNumber"
                          @change="(res) => multipleTableNumberChange(res, scope.row)" :min="0" :max="scope.row.number"
                          label="请输入内容"></el-input-number>

                        <!-- <el-input placeholder="本包数量" :ref="'thisPackNumber' + scope.row.id"
                      v-model="scope.row.thisPackNumber" @change="multipleTableNumberChange(scope.row)"></el-input> -->
                      </template>
                    </el-table-column>
                    <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                    <el-table-column prop="packSpec" show-overflow-tooltip label="包装规格" width="120" />

                    <el-table-column prop="price" label="单价" width="80"></el-table-column>
                    <el-table-column prop="batch" label="批次号" width="120" />
                    <el-table-column prop="validityDate" label="有效期" width="150">
                      <template slot-scope="scope">
                        {{
                          scope.row.validityDate
                            ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                            : ""
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="serialNo" label="序列号" width="120">
                    </el-table-column>
                    <el-table-column label="库存类型" width="80">
                      {{ form.categoryName }}
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="productRegistCertName" label="产品注册证"
                      width="180"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="productRegistCertNo" label="注册证号"
                      width="180"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="supplierName" label="供应商"
                      width="140"></el-table-column>
                  </el-table>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
                  <div style="width: 100%; display: flex; margin: 15px 10px">
                    <div class="start-label" />
                    <span class="text">打包预览</span>
                  </div>
                  <el-table :data="thisPackDetails" border style="width: auto; margin: 0 10px" stripe
                    :header-cell-style="{ background: '#DDEBFF' }" max-height="500" ref="thisPackTable" show-summary
                    :summary-method="getSummaries" height="200">
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品"
                      width="140"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号"
                      width="120"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家"
                      width="140"></el-table-column>
                    <el-table-column prop="number" label="数量" width="120">
                      <!-- <template slot-scope="scope">
                    <el-input placeholder="本包数量" v-model="scope.row.number"
                      @change="numberChange(scope.row)"></el-input>
                  </template> -->
                    </el-table-column>
                    <el-table-column prop="minUnit" label="最小单位" width="80"></el-table-column>
                    <el-table-column prop="price" label="单价" width="120"></el-table-column>
                    <el-table-column prop="batch" label="批次号" width="120" />
                    <el-table-column prop="amount" label="小计" width="120"></el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
            <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
              <div style="width: 100%; display: flex">
                <div class="start-label" />
                <span style="flex: 6" class="text">已打包</span>
                <div>
                  <el-dropdown @command="batchPrintChange2" style="margin: 10px 10px; float: right">
                    <el-button type="primary" size="small">
                      批量打印<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">RFID打印</el-dropdown-item>
                      <el-dropdown-item command="2">普通打印</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <el-table :data="form.packedDetails" border style="width: auto; margin: 0 10px" stripe
                @selection-change="handleSelectionChange" :header-cell-style="{ background: '#DDEBFF' }"
                ref="packedTable" max-height="500" :span-method="objectSpanMethod" height="260">
                <el-table-column align="center" type="selection" fixed width="55" />
                <el-table-column :show-overflow-tooltip="true" prop="no" label="包号/RFID" min-width="130"
                  fixed="left"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productName" label="产品"
                  min-width="140"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specName" label="规格型号"
                  min-width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" label="生产厂家"
                  min-width="140"></el-table-column>
                <el-table-column prop="number" label="数量" width="50"></el-table-column>
                <el-table-column prop="minUnit" label="最小单位" min-width="80"></el-table-column>
                <el-table-column prop="price" label="单价" width="60"></el-table-column>
                <el-table-column prop="batch" label="批次号" width="120" />
                <el-table-column prop="amount" label="小计" width="80"></el-table-column>
                <!-- printingTimes -->
                <el-table-column fixed="right" prop="printingTimes" width="80" label="打印次数"></el-table-column>
                <el-table-column label="操作" prop="operation" align="center" min-width="220" fixed="right">
                  <template slot-scope="scope">
                    <!-- <el-button size="mini" type="text" v-preventReClick @click="updatePack(scope.row)">修改</el-button> -->
                    <el-button size="mini" type="text" v-if="scope.row.useState != 1"
                      @click="deletePack(scope.row)">作废</el-button>
                    <el-button size="mini" type="text" @click="print(scope.row.no)">RFID打印</el-button>
                    <el-button size="mini" type="text" @click="print1(scope.row.no)">普通打印</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- <el-button type="primary" style="margin: 10px 10px; float: right"
                    @click="batchPrintChange(1)">批量打印</el-button> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
    </div>
    <BatchPackDialog :open="batchPackDialog" :packagedData="packagedData1" @cancel="batchPackDialogClose"
      @confirm="batchPackDialogConfirm" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  SavePack,
  GetApplyOutStockPackDetail,
  GetStockUpCheckPackDetail,
  GetPeriodStockPackViewModel,
  RemovePack,
  GetPackPrintData,
  SavePacks,
  GetPackNormalPrintData,
  RefreshPackNumber,
  CodingStockUpDistributionSendSrm
} from "@/api";
import BatchPackDialog from "@/components/batchPack-dialog";
import { Debounce } from "@/utils/utils";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    BatchPackDialog,
  },
  data() {
    return {
      form: {},
      editMode: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      thisPackDetails: [],
      udiNo: "",
      activeName: "first",
      id: 0,
      category: 0,
      lightRows: [],
      ids: [], // 多选框数据
      newArr: [],
      batchPrintType: null,
      batchPackDialog: false,
      packagedData1: [],
      creatPackLoading: false,
    };
  },
  computed: {
    system_setting() {
      return this.$store.getters.system_setting;
    },
  },

  created() {
    var query = this.$route.query;
    if (query.id) {
      this.id = query.id;
    }
    if (query.category) {
      this.category = query.category;
    }

    this.getPackInfo();
    this.udiNo = "";
    // this.activeName = 'first'
    this.thisPackDetails = [];
  },
  mounted() {
    this.rfidSocketApi.init(this.onmessage, this.onopen);
  },
  beforeDestroy() {
    this.rfidSocketApi.clearBingMethods();
  },
  methods: {
    cancel() {
      if (this.prevRoute.path == "/") {
        this.$router.go(-1);
      } else {
        this.routePushWithParams(this.prevRoute.path, this.$route.params);
      }
    },
    onmessage(e) {
      // window.console.log("收到消息啦:" + e.data);
      var data = JSON.parse(e.data);
      if (data.Successful) {
        this.$my_message("打印成功", "success");
      } else {
        this.$my_message("打印失败：" + data.Message, "error");
      }
    },
    onopen() {
      window.console.log("连接成功了哦");
    },






    printSingle(id, command) {
      return new Promise((resolve, reject) => {
        this.PrintAction({ id: id, type: command })
          .then(res => {
          })
      })

    },



    print1(no, notRefresh) {
      return new Promise((resolve, reject) => {
        return GetPackNormalPrintData({
          no: no,
          isSingle: this.activeName == 'first' ? 1 : 0
        }).then((res) => {
          var result = res.returnData

          var printData = this.printDataConvert(result.printData)
          this.sendPrintMessage(JSON.stringify(printData));

          if (!notRefresh) {
            this.getPackInfo();
          }

          resolve(res.returnData);
        });
      });
    },


    print(no, notRefresh) {
      return new Promise((resolve, reject) => {
        return GetPackPrintData({
          no: no,
        }).then((res) => {
          var action = "PrintSingle";
          if (no.startsWith("BDB")) {
            action = "PrintPack";
          }

          if (this.system_setting.RFIDTempSite) {
            this.$my_message("打印成功", "success");
            if (!notRefresh) {
              this.getPackInfo();
            }
            resolve(res.returnData);
            return
          }
          var data = {
            Action: action,
            Content: res.returnData,
          };
          this.rfidSocketApi.sendSock(data);

          if (!notRefresh) {
            this.getPackInfo();
          }

          resolve(res.returnData);
        });
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property !== "number" && column.property !== "amount") {
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });

      return sums;
    },
    getPackInfo() {
      if (this.category == 0) {
        GetApplyOutStockPackDetail({
          id: this.id,
        }).then((res) => {
          this.form = res.returnData;
          // 过滤掉可打包数量为0的项
          this.form.multipleDetails = this.form.multipleDetails.filter(item => {
            return item.number - item.packNumber - item.refundNumber > 0;
          });
          this.form.deptName = this.form.applyDeptName;
          this.form.deptId = this.form.applyDeptId;

          if (!this.form.packedDetails) {
            this.form.packedDetails = [];
          }
          this.getSpanArr(this.form.packedDetails);
        });
      } else if (this.category == 1) {
        GetStockUpCheckPackDetail({
          id: this.id,
        }).then((res) => {
          this.form = res.returnData;
          this.form.deptName = this.form.applyDeptName;
          this.form.deptId = this.form.applyDeptId;
          this.form.applyWarehouseId = this.form.warehouseId;
             // 过滤掉可打包数量为0的项
          this.form.multipleDetails = this.form.multipleDetails.filter(item => {
            return item.number - item.packNumber - item.refundNumber > 0;
          });
          if (!this.form.packedDetails) {
            this.form.packedDetails = [];
          }
          this.getSpanArr(this.form.packedDetails);
        });
      } else if (this.category == 2) {
        GetPeriodStockPackViewModel({
          id: this.id,
        }).then((res) => {
          this.form = res.returnData;
          this.form.deptName = this.form.applyDeptName;
          this.form.deptId = this.form.applyDeptId;
          this.form.applyWarehouseId = this.form.warehouseId
          // 过滤掉可打包数量为0的项
          this.form.multipleDetails = this.form.multipleDetails.filter(item => {
            return item.number - item.packNumber - item.refundNumber > 0;
          });
          if (!this.form.packedDetails) {
            this.form.packedDetails = [];
          }
          this.getSpanArr(this.form.packedDetails);
        });
      }
    },
    setRFID(row) {
      if(!this.form.singleDetails.some(e => e.rfid)){
        CodingStockUpDistributionSendSrm({id:this.form.id})
      }
      if (row.price != row.newPurchasePrice || row.billingPrice != row.newBillingPrice) {
        this.$confirm(
          `此耗材价格与供应商产品最新价格不一致，在这里赋码可能会影响到库存的价格和计费，确定要进行赋码操作吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.saveSinglePack(row);
        });
      } else {
        this.saveSinglePack(row);
      }
    },
    saveSinglePack(row) {
      var pack = this.outStockRow2RfidRow(row);
      var packs = [pack];
      SavePack({
        packs,
        packCategory: 0,
      }).then((res) => {
        row.rfid = res.returnData;

        this.udiNoChange(this.udiNo);
      });
    },
    savePacks() {
      if(!this.form.singleDetails.some(e => e.rfid)){
        CodingStockUpDistributionSendSrm({id:this.form.id})
      }
      if (!this.multipleSelection) {
        this.$my_message("请选择要赋码的数据", "warning");
        return;
      }
      var haveRfidRows = this.multipleSelection.filter(
        (e) => e.rfid != null && e.rfid != ""
      );
      if (haveRfidRows && haveRfidRows.length > 0) {
        this.$my_message("请选择未赋码的数据", "warning");
        return;
      }

      // this.multipleSelection.map(e => {
      //   e = this.outStockRow2RfidRow(e)
      //   return e
      // })
      for (var i = 0; i < this.multipleSelection.length; i++) {
        this.multipleSelection[i] = this.outStockRow2RfidRow(this.multipleSelection[i]);
      }

      SavePacks({
        packs: this.multipleSelection,
      }).then((res) => {
        this.getPackInfo();
      });
    },

    // 打包
    multipleTableNumberChange(val, row) {

      if (row.thisPackNumber > 0) {
        // if (row.thisPackNumber > row.number - row.packNumber) {
        //   console.log(row)
        //   this.$refs['thisPackNumber' + row.id].focus()
        //   this.$refs['thisPackNumber' + row.id]
        // }
        var rfidRow = this.outStockRow2RfidRow(row);
        rfidRow.number = row.thisPackNumber;
        rfidRow.amount = rfidRow.number * rfidRow.price;

        this.pushThisPackDetail(rfidRow);
      } else {
        this.thisPackDetails = this.thisPackDetails.filter((e) => e.detailId != row.id);
      }
    },
    pushThisPackDetail(row) {
      if (!this.thisPackDetails) {
        this.thisPackDetails = [];
      }
      let detail = this.thisPackDetails.find((e) => e.detailId == row.detailId);
      if (detail) {
        detail.number = row.number;
        detail.amount = detail.number * detail.price;
      } else {
        this.thisPackDetails.push(row);
      }
    },
    numberChange(row) {
      if (row.number == 0) {
        this.thisPackDetails = this.thisPackDetails.filter((e) => e.id != row.id);
      }
      let detail = this.form.multipleDetails.find((e) => e.id == row.detailId);
      if (detail) {
        detail.thisPackNumber = row.number;
      }
    },
    creatPack: Debounce(function() {
      this.creatPackLoading = true
      // 校验
      for (let i = 0; i < this.thisPackDetails.length; i++) {
        let detail = this.form.multipleDetails.find(
          (e) => e.id == this.thisPackDetails[i].detailId
        );
        // console.log(detail.number, detail.packNumber, detail.thisPackNumber, detail.packNumber + detail.thisPackNumber * 1)
        if (
          detail &&
          detail.number <
          detail.packNumber + detail.thisPackNumber * 1 + detail.refundNumber
        ) {
          this.creatPackLoading = false
          this.$my_message(
            `本包明细第${i + 1}行：${detail.productName} ${detail.specName
            } 打包数量超出可打包数量`,
            "warning"
          );
          return;
        }
      }

      // 校验价格
      let priceWarning = false;
      const h = this.$createElement;
      let content = [h("p", "本包明细存在以下产品价格与供应商产品价格不一致：")];
      for (let i = 0; i < this.thisPackDetails.length; i++) {
        let detail = this.form.multipleDetails.find(
          (e) => e.id == this.thisPackDetails[i].detailId
        );
        if (
          detail.price != detail.newPurchasePrice ||
          detail.billingPrice != detail.newBillingPrice
        ) {
          priceWarning = true; //产品：[${detail.productName}],规格：[${detail.specName}],
          content.push(
            h(
              "p",
              {
                style: "color:red",
              },
              `第${i + 1}行：采购价:[${detail.price}],计费价:[${detail.billingPrice
              }],供应商产品采购价:[${detail.newPurchasePrice}],计费价:[${detail.billingPrice
              }]`
            )
          );
        }
      }
      content.push(h("p", "确定要继续打包吗？"));

      if(this.form.packedDetails.length == 0){
        CodingStockUpDistributionSendSrm({id:this.form.id})
      }
      if (priceWarning) {
        this.$confirm("提示", {
          title: "提示",
          type: "warning",
          message: h("div", content),
        }).then(() => {
          this.saveMultiplePack();
        }).catch(() => {
          this.creatPackLoading = false
        })
      } else {
        this.saveMultiplePack();
      }
    }),
    saveMultiplePack() {
      SavePack({
        packs: this.thisPackDetails,
        packCategory: 1,
      }).then((res) => {
        if (!res.successful) {
          this.creatPackLoading = false
          return;
                
        }
        this.creatPackLoading = false
        this.thisPackDetails = [];
        this.getPackInfo();
      }).finally(() => {
        this.creatPackLoading = false
      })
    },

    handleSelectionChange(selection) {
      console.log(selection);

      this.multipleSelection = selection;

      // 只能选择状态为打印 = rfid 不等于空
      // this.ids = selection.map((item) => item.id);
      // this.multiple = !selection.length;
      // console.log(this.ids, "this.ids");
    },
    // checkboxInit (row, index) {
    //   if (row.rfid == null || row.rfid == '') {
    //     return 0; //不可勾选 置灰
    //   } else {
    //     return 1;
    //   }
    // },
    batchPrintChange1(val) {
      this.batchPrintType = val
      this.batchPrintChange()
    },
    batchPrintChange2(val) {
      this.batchPrintType = val
      this.batchPrintChange(1)
    },
    batchPrintChange(num) {
      if (!this.multipleSelection) {
        this.$my_message("请选择要打印的数据", "warning");
        return;
      }
      var notHaveRfidRows = this.multipleSelection.filter(
        (e) => e.rfid == null || e.rfid == ""
      );
      if (notHaveRfidRows && notHaveRfidRows.length > 0 && !num) {
        this.$my_message("请选择已经赋码的数据", "warning");
        return;
      }

      const map = new Map();
      for (let i = 0; i < this.multipleSelection.length; i++) {
        if ("rfid" in this.multipleSelection[i]) {
          this.multipleSelection[i].no = this.multipleSelection[i].rfid;
        }
      }
      this.newArr = this.multipleSelection.filter(
        (key) => !map.has(key.no) && map.set(key.no, 1)
      );

      this.printForeach(0);
    },
    printForeach(i) {
      if (i != this.newArr.length) {
        let notRefresh = true;
        if (i == this.newArr.length - 1) {
          notRefresh = false;
        }
        if (this.batchPrintType == 1) {
          this.print(this.newArr[i].no, notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        } else {
          this.print1(this.newArr[i].no, notRefresh).then((res) => {
            i++;
            setTimeout(() => {
              this.printForeach(i);
            }, 1000);
          });
        }

      } else {
        if (this.$refs.customTable) {
          this.$refs.customTable.callChildMethod().clearSelection()
        }
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection()
        }
        // this.getData()
      }
    },
    // 已打包明细
    getSpanArr(data) {
      this.spanArr = [];
      if (!data) {
        return;
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].no === data[i - 1].no) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        // console.log(this.spanArr);
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        column.property == "no" ||
        column.property == "operation" ||
        columnIndex === 0
      ) {
        // if (columnIndex === 0 || columnIndex === 9) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        // console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    updatePack(row) {
      let packDetails = this.form.packedDetails.filter((e) => e.no == row.no);
      this.thisPackDetails = JSON.parse(JSON.stringify(packDetails));

      this.form.multipleDetails.map((item, index) => {
        let detail = this.thisPackDetails.find((e) => e.detailId == item.id);
        if (detail) {
          item.thisPackNumber = detail.number;

          item.packNumber = item.packNumber - detail.number;

        }
        this.$set(this.form.multipleDetails, index, {
          ...item,
        });
        // return item
      });
    },
    deletePack(row) {
      this.$confirm(`确定要作废包号：${row.no}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return RemovePack({
            no: row.no,
          });
        })
        .then((res) => {
          if (!res.successful) {
            return;
          }
          this.getPackInfo();
          this.$my_message("删除成功", "success");
        });
    },

    PrintDialogClose() {
      this.printDialogVisible = false;
    },
    outStockRow2RfidRow(row) {
      var rfidRow = JSON.parse(JSON.stringify(row));
      rfidRow.dataId = this.id;
      rfidRow.dataNo = this.form.no;
      rfidRow.category = this.category;
      rfidRow.warehouseId = this.form.applyWarehouseId;
      rfidRow.detailId = row.id;
      rfidRow.deptId = this.form.deptId;
      if (this.category == 1) {
        rfidRow.stockCategory = 1;
      } else if (this.category == 0) {
        rfidRow.stockCategory = this.form.category;
      }
      // 期初
      else if (this.category == 2) {
        rfidRow.stockCategory = 0;
      }
      return rfidRow;
    },
    udiNoChange(val) {
      this.lightRows = [];
      if (!val) {
        return;
      }
      this.form.singleDetails.map((item, index) => {
        if (!item.rfid && item.mainNo) {
          if (val.startsWith(item.mainNo)) {
            var mainNo = item.mainNo;
            var traceNo = val.substr(mainNo.length, val.length - mainNo.length);
            if (traceNo && traceNo.length > 0) {
              if (val == item.mainNo + "" + item.traceNo) {
                this.lightRows.push(index);
              }
            } else {
              this.lightRows.push(index);
            }
          }
        }
      });
    },
    rowClass({ row, rowIndex }) {
      if (this.lightRows.indexOf(rowIndex) != -1) {
        return {
          "background-color": "rgba(185,221,249,0.75)",
        };
      }
    },

    batchPackEvt() {
      if (this.multipleSelection?.length == 0) {
        this.$message.error('请勾选数据')
        return
      }
    if(this.form.packedDetails.length == 0){
        CodingStockUpDistributionSendSrm({id:this.form.id})
      }
      this.packagedData1 = this.multipleSelection?.map(item => {
        return {
          ...item,
          quantitySum: item.number - item.packNumber - item.refundNumber,
          quantityPerPackage: 1,
        }
      })

      this.batchPackDialog = true

    },
    batchPackDialogClose() {
      this.packagedData1 = []
      this.batchPackDialog = false
    },
    batchPackDialogConfirm(data) {
      let arr = data.map(res => this.outStockRow2RfidRow(res))
      arr.forEach(item => {
        item.number = item.quantityPerPackage
      })
      SavePack({
        packs: arr,
        packCategory: 1,
        packCount: arr[0].packNum
      }).then(res => {
        this.$message.success('打包成功')
        this.$refs.singleTable.clearSelection()
        this.getPackInfo();
        this.batchPackDialogClose()
      })
    },
    refreshEvt(){
      if (this.multipleSelection.length==0) {
        this.$message.warning('请先勾选数据')
        return
      }
        RefreshPackNumber(this.multipleSelection).then(res => {
          this.getPackInfo();
          this.$message.success('刷新成功')
        })
    }
},
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}

/deep/.el-table__row td {
  padding: 5px 0 !important;
}
</style>
